import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { openTermsModal } from "TicketAction";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ContentListItem from "./content-item.js";
import LocaleStrings from "Languages";

class DeafultTerms extends Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);

    this.state = {
      copied: false,
      privacy_header1:
        "Thank you for deciding to participate in <EVENT NAME>. As the official organiser, <ORGANISER NAME> assures complete data security and information protection. Cutting-edge data security and data handling policies are followed by us, so that you do not have to worry about anything.",
      privacy_header2:
        "Before proceeding to purchasing tickets for <EVENT NAME>, we would strongly recommend you to go through our privacy policy statements as listed below. In case if you have any further queries, kindly send an email to <support email id>.",
      privacy_policy: [
        { text: "What Information Do We Collect?" },
        {
          text: "<ORGANISER NAME> collects a set of information from you - the buyer - during the ticket-purchasing process. These information, include, but are not limited to:",
        },
        { text: "Full name" },
        { text: "Email id" },
        { text: "Credit card information" },
        { text: "Bank account information (if required)." },
        { text: "Address" },
        { text: "IP address" },
        { text: "Location data" },
        { text: "Contact Number" },
        { text: "Electronic payment/transaction information." },
        {
          text: "Please note that only users above the age of <MINIMUM AGE> can purchase tickets to <EVENT NAME>. By purchasing a ticket, you automatically indicate that you are at least <MINIMUM AGE> years old, and as such, are capable to handle all responsibilities as a <EVENT NAME> attendee.",
        },
        {
          text: "Apart from the above, we also collect ‘aggregate information’ - which refer to the insights obtained from buyer behaviour. This information includes things like your purchase decisions, interactions with notifications, duration of stay on a particular page or section, etc. - and are not ‘personal’ in any way. <ORGANISER NAME> collects such information to gain actionable insights and improve its services as an event organiser, on an ongoing basis.",
        },
        { text: "Why Do We Collect Information?" },
        {
          text: "Personally identifiable information and aggregate information are collected by <ORGANISER NAME> for:",
        },
        {
          text: "Ensuring smooth, secure service delivery (here, delivery of <EVENT NAME> ticket(s)).",
        },
        { text: "Enabling financial transactions and verifying the same." },
        {
          text: "Creating and maintaining your user account on the <ORGANISER NAME> platform.",
        },
        {
          text: "Sending personalised communications, including confirmation email(s) on successful purchase of <EVENT NAME> tickets.",
        },
        {
          text: "Sharing select promotional material, special offers, and other updates that we feel you might be interested in (you can opt out from such emails).",
        },
        { text: "Implementing our terms of use." },
        { text: "Enhancing the overall user-experience factor." },
        {
          text: "In particular, the ‘personally identifiable’ information collected by <ORGANISER NAME> is used for:",
        },
        {
          text: "Processing ticket bookings (from bookings and payments, to ticket delivery).",
        },
        {
          text: "Communicating with you via emails (ticket purchase confirmations, event updates, cancellations, etc.).",
        },
        { text: "Handling payment and/or booking-related queries." },
        {
          text: "Performing sales analyses, tracking transactions, initiating marketing campaigns and more.",
        },
        { text: "GDPR Compliance" },
        {
          text: "<ORGANISER NAME> is fully compliant with the latest GDPR regulations. For delivering seamless event ticketing services to you, we share your data with select authorised and licensed third-party service providers (partners). All partners of <ORGANISER NAME>, including Eventify (eventify.io) are GDPR-compliant.",
        },
        { text: "Use Of Cookies" },
        {
          text: "‘Cookies’ are small internet files that reside in your web browser. <ORGANISER NAME> uses cookies to bring to you a more personalised experienced on the website (LINK TO TICKETING URL). If you delete cookies from your browser, we will not be able to provide this extra level of personalisation in our services. As such, accepting our cookie policy is strongly recommended.",
        },
        { text: "Data Protection Assurance By <ORGANISER NAME>" },
        {
          text: "We are committed to keeping your personal, financial, and other related information safe at all times. The information you provide is encrypted and stored in our secure database. Please note that <ORGANISER NAME> will never use/copy/sell/share your information to any unauthorised third-party for advertising/marketing purposes without your consent.",
        },
        {
          text: "We also request you to be vigilant about your own data security while purchasing <EVENT NAME> tickets. Make sure that your account credentials are secure, use a trusted system to complete your transaction(s), and your internet connection is not acting up. In case you feel that your account has been compromised in any way, let us know immediately at <support email id>.",
        },
        { text: "Retention Of Data" },
        {
          text: "<ORGANISER NAME> will retain your personal data for a time-period that is deemed to be ‘reasonably necessary’. However, in general, buyer information is not retained after a period of <number> years. IP addresses are removed after <number> days.",
        },
        {
          text: "In select circumstances, we might retain buyer details, to settle legal matters, litigations, disputes and the like. The details are removed as soon as the concerned issue(s) are resolved.",
        },
        { text: "What RIGHTS Do You Have?" },
        {
          text: "When you transact with <ORGANISER NAME>, you are protected by all relevant GDPR regulations. The rights you retain are as follows:",
        },
        {
          text: "Right to information (You can, at any time, demand to know how your information is being used).",
        },
        {
          text: "Right to access (You can request a copy of all the personal records that we are in possession of).",
        },
        {
          text: "Right to rectification (You can request changes in personal records, particularly in case of inaccuracies).",
        },
        {
          text: "Right to erasure (You can instruct us to remove section(s) from your personal records).",
        },
        {
          text: "Right to processing objections (You can tell us to stop processing your personal data).",
        },
        { text: "External Links" },
        {
          text: "The official organiser of <EVENT NAME> is <ORGANISER NAME> (website URL). Please note that, on our website there might be links to third-party entities. <ORGANISER NAME> does not, in any way, vouch for the authenticity, relevance or reliability of facts/opinions/stats present in such external resources.",
        },
        { text: "Contact Information" },
        { text: "<put contact info here>" },
      ],
      privacy_footer: "",
      terms_header:
        "Thank you for your interest in participating in <EVENT NAME> . Before you proceed to purchase tickets, we strongly recommend you to go through the following terms and conditions:",
      terms_conditions: [
        {
          text: "In this section, words like ‘holder’, ‘bearer’, and ‘purchaser’ will refer to you - the person who will buy the tickets to <EVENT NAME>. On the other hand, ‘our’, ‘us’, ‘we’, ‘issuer’, ‘provider’ and similar terms will indicate the organisers of <EVENT NAME> - <ORGANISER NAME>.",
        },
        {
          text: "By opting to purchase, allocate or possess tickets to <EVENT NAME>, you automatically agree to our terms of use. If you have problems with any of the clauses listed below or do not agree with the risk allocations mentioned here, please do not purchase tickets or try to enter the <EVENT NAME> premises.",
        },
        {
          text: "Please note that <ORGANISER NAME> reserves the right to make changes, revisions, and amendments, or add/remove sections from this set of terms and conditions - without any prior notifications to you. Such changes will be duly reflected on the website of the organiser (WEBSITE ADDRESS HERE). These changes will relate back to the date of purchase of <EVENT NAME> tickets.",
        },
        {
          text: "The price of one <EVENT NAME> ticket is <PRICE>. This figure is non-negotiable.",
        },
        {
          text: "The ticket you purchase represents a revocable license for you to access <VENUE NAME> on <DATES>, when <EVENT NAME> is scheduled to be hosted. The license includes the revocable right to attending the <EVENT NAME>. This license can be revoked at any time by the issuer at its sole discretion, without any prior notifications or compensation options. If the license is revoked, you will not be granted entry at the venue.",
        },
        {
          text: "The bearer has to assume full responsibility of the <EVENT NAME> tickets, once (s)he receives it. <ORGANISER NAME> has no liabilities - financial, legal, or otherwise - in case the delivered tickets are stolen, lost, damaged, destroyed or rendered unusable in any other way.",
        },
        {
          text: "Kindly note that <EVENT TICKETING WEBSITE> is the sole authorised source for purchasing <EVENT NAME> tickets. If you obtain your ticket(s) from any other unauthorised source, you take on the risks of those tickets turning out to be counterfeit or reported to be stolen. The issuer has the right to dishonour such stolen/counterfeit tickets and declare them as void.",
        },
        {
          text: "The <EVENT NAME> tickets delivered to you are not meant to be used for illegal reselling, copying, reproducing, or misrepresenting in any form. You cannot use the ticket(s) for any promotional/advertising purposes either (including sweepstakes and competitions) without our prior approval. Any proven record of such activities will result in immediate seizure and cancellation of your ticket(s).",
        },
        {
          text: "Please note that <EVENT NAME> tickets cannot be redeemed against cash, credits, or any other benefits.",
        },
        {
          text: "<ORGANISER NAME> has the right to investigate if there has been any violation of the <EVENT NAME> ticketing terms and conditions. In case of any conflicts, the decision of <ORGANISER NAME> will be deemed final (i.e., the issuer will remain the final arbiter in cases of disputes).",
        },
        {
          text: "The event service will be deemed to have been delivered in its entirety as soon as <EVENT NAME> starts on <DATE>. From that point on, no refund requests will be entertained.",
        },
        {
          text: "If you are not able to access any particular section(s) of the venue - <VENUE NAME> - due to delays, federal regulations, organiser policies, weather-related problems, emergencies, venue shutdown/evacuation or any other reason, you will not be eligible for any refunds or future credits.",
        },
        {
          text: "If you are not able to access any particular section(s) of the venue - <VENUE NAME> - due to delays, federal regulations, organiser policies, weather-related problems, emergencies, venue shutdown/evacuation or any other reason, you will not be eligible for any refunds or future credits.",
        },
        {
          text: "If <EVENT NAME> is cancelled in its entirety due to any unforeseen circumstances, <ORGANISER NAME> has the sole and absolute right to: i) reschedule the event, or ii) issue a partial/full refund, or iii) not issue any refunds. Please note that the decision of the issuer in such cases will be deemed final and binding.",
        },
        {
          text: "If <EVENT NAME> is cancelled due to any factors or causes not in the control of the issuer, the latter will offer a partial or full refund, or postpone the event, or provide a comparable ‘make good’ option. These factors will be inclusive of, but not limited to, natural disasters, federal/state announcements, strikes, delays in production, and the like. Once again, the decision of <ORGANISER NAME> will be considered final.",
        },
        {
          text: "If <EVENT NAME> has to be rescheduled to other dates, you will not be eligible for any refunds. In case the event is fully canceled, the refund, if issued, will include ONLY the face value/printed value of the ticket(s). The bearer cannot, under any circumstances, claim refunds on shipping fees, processing fees, handling fees, and such other charges.",
        },
        {
          text: "Losses, if any, occurring due to foreign exchange fluctuations at the time of refunds, have to be borne by the purchaser. <ORGANISER NAME> cannot be, in any way, held liable for that.",
        },
        {
          text: "All ticket sales are deemed as FINAL TRANSACTIONS. There will be no ticket returns/exchanges/cancellations.",
        },
        {
          text: "<EVENT NAME> is a ‘rain or shine’ event. By purchasing the event tickets, you automatically confirm that you/the attendee(s) are of the ‘minimum age’ or older, at the time of buying the ticket(s). The ‘minimum age’ for attending <EVENT NAME> is <AGE>.",
        },
        {
          text: "If it is proven beyond doubt at the venue that an attendee is below the ‘minimum age’, (s)he will not be granted entry to <EVENT NAME>. No refunds, full or partial, will be issued either.",
        },
        {
          text: "At the time of entering the event venue, you are required to produce the ticket and a valid identification document (ID). By presenting an ID, you confirm that all details present on it are accurate and updated.",
        },
        {
          text: "By purchasing <EVENT NAME> tickets and presenting the same at the venue, you give your consent to <ORGANISER NAME> to collect certain information about yourself (name, picture, date of birth, gender, address, etc.) for verification and storage.",
        },
        {
          text: "You hereby agree to forego all types of surcharge claims - full or in part - and all claims & entitlements related to it.",
        },
        {
          text: "<ORGANISER NAME> does not take any responsibility to personal/financial damages caused to you at the venue, or for any items lost/stolen/misplaced at the venue. Financial reimbursement claims on these counts will not be entertained.",
        },
        {
          text: "<EVENT NAME> and <ORGANISER NAME> follow a common ‘zero-tolerance policy’ towards unauthorised drug usage or carrying at the venue, AND towards any type of behaviour/actions that can be interpreted as lewd or obscene. If you are found in possession of prohibited items at <EVENT NAME> and/or if you indulge in any objectionable action, your participation in the event will be terminated immediately. Your event ticket(s) will become void from that point on.",
        },
        {
          text: "Please note that you purchase <EVENT NAME> tickets on your own free will. As such, you do not have the right to initiate a chargeback claim or dispute on the provider of the credit card/debit card that had been used for the transaction. Further refund/return/cancellation requests will not be entertained either.",
        },
        {
          text: "In all cases of disputes between the ticket-bearer and the ticket-issuer, the decision of the latter will be deemed final. In case a dispute cannot be resolved, the help of an independent third-party arbiter will be sought.",
        },
      ],
      terms_footer:
        "We really hope you will have a great time at <EVENT NAME>. You can get your tickets here <link to TICKETING PAGE>.",
      thankyou_header:
        "Thank you for showing your interest in our <EVENT_NAME>",
      thank_you: [
        { text: "Thank you for your interest in our <EVENT_NAME>. " },
      ],
      thankyou_footer: "",
    };
  }

  close() {
    this.props.openTermsModal({ showModal: false, open: "" });
  }

  renderContent = () => {
    let record = this.state.privacy_policy;
    if (this.props.showDefaultTermsModal.open == "termsandconditions") {
      record = this.state.terms_conditions;
    } else if (this.props.showDefaultTermsModal.open == "congratulations") {
      record = this.state.thank_you;
    }

    return _.map(record, (item, index) => (
      <ContentListItem key={index} id={index} item={item} />
    ));
  };

  copyText = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  render() {
    let { showDefaultTermsModal } = this.props;

    let header = (
      <span>
        {this.state.privacy_header1}
        <br></br>
        <br></br>
        {this.state.privacy_header2}
      </span>
    );
    let footer = this.state.privacy_footer;
    if (showDefaultTermsModal.open == "termsandconditions") {
      header = this.state.terms_header;
      footer = this.state.terms_footer;
    } else if (showDefaultTermsModal.open == "congratulations") {
      header = this.state.thankyou_header;
      footer = this.state.thankyou_footer;
    }

    var defaultData =
      this.state.privacy_header1 + "\n" + this.state.privacy_header2;
    let record = this.state.privacy_policy;
    if (showDefaultTermsModal.open == "termsandconditions") {
      defaultData = this.state.terms_header + "\n";
      record = this.state.terms_conditions;
    } else if (showDefaultTermsModal.open == "congratulations") {
      defaultData = this.state.thankyou_header + "\n";
      record = this.state.thank_you;
    }

    _.map(
      record,
      (item, index) => (defaultData = defaultData + item.text + "\n")
    );

    defaultData = defaultData + footer;

    return (
      <div>
        <Modal
          className="modal-container terms-privacy-modalResize"
          show={showDefaultTermsModal.showModal === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>
              <div className="title-modal">
                {showDefaultTermsModal.open == "termsandconditions"
                  ? LocaleStrings.tickets_setting_form_label_terms_conditions
                  : showDefaultTermsModal.open == "privacy"
                  ? LocaleStrings.tickets_setting_form_label_privacy_policy
                  : LocaleStrings.tickets_setting_form_label_congratulation_message}{" "}
              </div>
            </Modal.Title>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.close()}
              // style={{textAlign:'end'}}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>

          <Modal.Body
            className={
              showDefaultTermsModal.open == "termsandconditions" ||
              showDefaultTermsModal.open == "privacy"
                ? "scrollable-modal"
                : ""
            }
          >
            <div style={{ padding: "20px 20px 0px" }}>
              <Button
                className="button-theme button-theme-blue"
                bsStyle="primary"
                style={{ marginBottom: 10, marginRight: 20 }}
              >
                <CopyToClipboard text={defaultData} onCopy={this.copyText}>
                  <div>
                    <i className="fa fa-files-o" aria-hidden="true"></i>&nbsp;
                    {LocaleStrings.tickets_setting_form_text_copy_template}
                  </div>
                </CopyToClipboard>
              </Button>
              {this.state.copied ? (
                <span style={{ color: "black" }}>{LocaleStrings.copied}.</span>
              ) : null}

              <p>{header}</p>
              {this.renderContent()}
              <p>{footer}</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="" className="button-theme" onClick={this.close}>
              {LocaleStrings.button_close}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showDefaultTermsModal: state.showDefaultTermsModal,
  };
}

export default connect(mapStateToProps, { openTermsModal })(DeafultTerms);
